import { a as e, c as t, d as n, f as r, g as i, h as a, i as o, l as s, m as c, n as l, o as u, p as d, r as f, s as p, t as m, u as h, v as g, y as _ } from "./generated-DMzJ0dir.js";
import { t as v } from "./useAddressService-DSXB4Lwl.js";
import { z as y } from "zod";
//#region src/generated/schemas.gen.ts
var b = {
	type: "string",
	enum: /* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."),
	description: "ISO 3166-1 alpha-2 code.",
	examples: ["NL", "US"]
}, x = {
	type: "string",
	enum: /* @__PURE__ */ "AL.AK.AZ.AR.CA.CO.CT.DE.FL.GA.HI.ID.IL.IN.IA.KS.KY.LA.ME.MD.MA.MI.MN.MS.MO.MT.NE.NV.NH.NJ.NM.NY.NC.ND.OH.OK.OR.PA.RI.SC.SD.TN.TX.UT.VT.VA.WA.DC.WV.WI.WY".split("."),
	examples: ["AL", "WY"]
}, S = {
	type: "string",
	enum: [
		"AB",
		"BC",
		"MB",
		"NB",
		"NL",
		"NS",
		"NT",
		"NU",
		"ON",
		"PE",
		"SK",
		"QC",
		"YT"
	],
	examples: ["AB", "YT"]
}, C = {
	oneOf: [
		{
			type: "object",
			properties: {
				city: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "City name."
				},
				postOfficeBox: {
					type: "boolean",
					description: "Whether the address is a post office box."
				},
				street: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Street name."
				},
				houseNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number."
				},
				latitude: {
					type: "number",
					minimum: -90,
					maximum: 90,
					description: "Geodetic latitude."
				},
				longitude: {
					type: "number",
					minimum: -180,
					maximum: 180,
					description: "Geodetic longitude."
				},
				municipality: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Municipality name."
				},
				countryCode: {
					type: "string",
					enum: ["BE"],
					description: "ISO 3166-1 alpha-2 code."
				},
				postalCode: {
					type: "string",
					minLength: 1,
					maxLength: 15,
					description: "Postal code."
				},
				boxNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "Bus number, only for Belgian addresses."
				}
			},
			required: [
				"city",
				"postOfficeBox",
				"street",
				"countryCode",
				"postalCode"
			]
		},
		{
			type: "object",
			properties: {
				city: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "City name."
				},
				postOfficeBox: {
					type: "boolean",
					description: "Whether the address is a post office box."
				},
				street: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Street name."
				},
				houseNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number."
				},
				latitude: {
					type: "number",
					minimum: -90,
					maximum: 90,
					description: "Geodetic latitude."
				},
				longitude: {
					type: "number",
					minimum: -180,
					maximum: 180,
					description: "Geodetic longitude."
				},
				municipality: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Municipality name."
				},
				countryCode: {
					type: "string",
					enum: /* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."),
					description: "ISO 3166-1 alpha-2 code."
				},
				houseNumberSuffix: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number suffix."
				},
				postalCode: {
					type: "string",
					minLength: 1,
					maxLength: 15,
					description: "Postal code."
				}
			},
			required: [
				"city",
				"postOfficeBox",
				"street",
				"countryCode"
			]
		},
		{
			type: "object",
			properties: {
				city: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "City name."
				},
				postOfficeBox: {
					type: "boolean",
					description: "Whether the address is a post office box."
				},
				street: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Street name."
				},
				houseNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number."
				},
				latitude: {
					type: "number",
					minimum: -90,
					maximum: 90,
					description: "Geodetic latitude."
				},
				longitude: {
					type: "number",
					minimum: -180,
					maximum: 180,
					description: "Geodetic longitude."
				},
				municipality: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Municipality name."
				},
				countryCode: {
					type: "string",
					enum: ["NL"],
					description: "ISO 3166-1 alpha-2 code."
				},
				postalCode: {
					type: "string",
					minLength: 1,
					maxLength: 15,
					description: "Postal code."
				},
				houseNumberSuffix: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number suffix."
				}
			},
			required: [
				"city",
				"postOfficeBox",
				"street",
				"countryCode",
				"postalCode"
			]
		}
	],
	examples: [
		{
			city: "Hoofddorp",
			countryCode: "NL",
			houseNumber: "31",
			houseNumberSuffix: "",
			latitude: 52.294862532732346,
			longitude: 4.710693735051177,
			municipality: "Haarlemmermeer",
			postalCode: "2132JE",
			postOfficeBox: !1,
			street: "Antareslaan"
		},
		{
			city: "Amsterdam",
			countryCode: "NL",
			houseNumber: "1",
			houseNumberSuffix: "A1",
			latitude: 52.377778951201,
			longitude: 4.9055895401203,
			municipality: "Amsterdam",
			postalCode: "1000AA",
			postOfficeBox: !0,
			street: "Postbus"
		},
		{
			city: "New York",
			countryCode: "US",
			houseNumber: "767",
			houseNumberSuffix: "",
			latitude: 40.76384629446427,
			longitude: -73.97289035919462,
			municipality: "New York",
			postalCode: "10153",
			postOfficeBox: !1,
			street: "Fifth Avenue"
		},
		{
			city: "Dubai",
			countryCode: "AE",
			houseNumber: "1",
			latitude: 25.197197,
			longitude: 55.2743763,
			municipality: "Dubai",
			postOfficeBox: !1,
			street: "Sheikh Mohammed bin Rashid Blvd"
		}
	]
}, w = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, T = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, E = {
	type: "object",
	properties: { valid: { type: "boolean" } },
	required: ["valid"],
	examples: [{ valid: !0 }, { valid: !1 }]
}, D = y.enum([
	"street",
	"houseNumber",
	"houseNumberSuffix",
	"boxNumber",
	"postalCode",
	"city",
	"region",
	"state",
	"additionalInformation"
]), O = y.strictObject({
	required: y.boolean().meta({ description: "Overrides the baseline requiredness for this field in this country. Ignored for postalCode, whose requiredness derives from `pattern` presence." }).optional(),
	pattern: y.instanceof(RegExp).meta({ description: "postalCode only — format regex used to validate the postal code. Its presence marks the postal code as required for the country." }).optional()
}), k = y.partialRecord(D, O).refine((e) => !("postalCode" in e) || e.postalCode?.pattern !== void 0, {
	error: "A postalCode rule must include a `pattern` — postal-code requiredness derives from pattern presence.",
	path: ["postalCode"]
});
y.partialRecord(p, k);
var A = {
	street: !0,
	houseNumber: !1,
	city: !0,
	postalCode: !0,
	houseNumberSuffix: !1,
	boxNumber: !1,
	region: !1,
	state: !1,
	additionalInformation: !1
}, j = {
	AD: { postalCode: { pattern: /^AD[0-9]{3}$/ } },
	AF: { postalCode: { pattern: /^[0-9]{4}$/ } },
	AL: { postalCode: { pattern: /^[0-9]{4}$/ } },
	AM: { postalCode: { pattern: /^[0-9]{4}$/ } },
	AQ: { postalCode: { pattern: /^BIQQ(\\s|-)?1ZZ$/ } },
	AR: { postalCode: { pattern: /^[0-9]{4}$/ } },
	AS: { postalCode: { pattern: /^[0-9]{5}$/ } },
	AT: { postalCode: { pattern: /^[0-9]{4}$/ } },
	AU: { postalCode: { pattern: /^[0-9]{4}$/ } },
	AZ: { postalCode: { pattern: /^AZ(\\s|-)?[0-9]{4}$/ } },
	BA: { postalCode: { pattern: /^[0-9]{5}$/ } },
	BB: { postalCode: { pattern: /^(BB)?\d{5}$/ } },
	BD: { postalCode: { pattern: /^[0-9]{4}$/ } },
	BE: { postalCode: { pattern: /^[1-9][0-9]{3}$/ } },
	BG: { postalCode: { pattern: /^[0-9]{4}$/ } },
	BH: { postalCode: { pattern: /^[0-9]{3,4}$/ } },
	BN: { postalCode: { pattern: /^[A-Z]{2}[0-9]{4}$/ } },
	BR: { postalCode: { pattern: /^[0-9]{5}(\s|-)?[0-9]{3}$/ } },
	BT: { postalCode: { pattern: /^[0-9]{5}$/ } },
	BY: { postalCode: { pattern: /^[0-9]{6}$/ } },
	CA: { postalCode: { pattern: /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z]\s?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/ } },
	CH: { postalCode: { pattern: /^[0-9]{4}$/ } },
	CL: { postalCode: { pattern: /^[0-9]{3}(\s|-)?[0-9]{4}$/ } },
	CN: { postalCode: { pattern: /^[0-9]{6}$/ } },
	CO: { postalCode: { pattern: /^[0-9]{6}$/ } },
	CR: { postalCode: { pattern: /^[0-9]{5}$/ } },
	CU: { postalCode: { pattern: /^[0-9]{5}$/ } },
	CV: { postalCode: { pattern: /^[0-9]{4}$/ } },
	CY: { postalCode: { pattern: /^[0-9]{4}$/ } },
	CZ: { postalCode: { pattern: /^[0-9]{3}\s?[0-9]{2}$/ } },
	DE: { postalCode: { pattern: /^[0-9]{5}$/ } },
	DK: { postalCode: { pattern: /^(DK(\s|-)?)?[0-9]{4}$/ } },
	DO: { postalCode: { pattern: /^[0-9]{5}$/ } },
	DZ: { postalCode: { pattern: /^[0-9]{5}$/ } },
	EC: { postalCode: { pattern: /^[0-9]{6}$/ } },
	EE: { postalCode: { pattern: /^[0-9]{5}$/ } },
	EG: { postalCode: { pattern: /^[0-9]{5}$/ } },
	ES: { postalCode: { pattern: /^[0-9]{5}$/ } },
	ET: { postalCode: { pattern: /^[0-9]{4}$/ } },
	FI: { postalCode: { pattern: /^[0-9]{5}$/ } },
	FK: { postalCode: { pattern: /^FIQQ(\s|-)?1ZZ$/ } },
	FO: { postalCode: { pattern: /^[0-9]{3}$/ } },
	FR: { postalCode: { pattern: /^[0-9]{5}$/ } },
	GB: { postalCode: { pattern: /^(([A-Z][0-9]|[A-Z][0-9]{2}|[A-Z][0-9][A-Z]|[A-Z]{2}[0-9]|[A-Z]{2}[0-9]{2}|[A-Z]{2}[0-9][A-Z])[\s-]?[0-9][A-Z]{2})$|^GIR\s?0AA$/ } },
	GE: { postalCode: { pattern: /^[0-9]{4}$/ } },
	GF: { postalCode: { pattern: /^973[0-9]{2}$/ } },
	GG: { postalCode: { pattern: /^GY[0-9]{1,2}\s?[0-9][A-Z]{2}$/ } },
	GI: { postalCode: { pattern: /^GX11(\s|-)?1AA$/ } },
	GL: { postalCode: { pattern: /^[0-9]{4}$/ } },
	GP: { postalCode: { pattern: /^971[0-9]{2}$/ } },
	GR: { postalCode: { pattern: /^[0-9]{3}\s?[0-9]{2}$/ } },
	GT: { postalCode: { pattern: /^[0-9]{5}$/ } },
	GW: { postalCode: { pattern: /^[0-9]{4}$/ } },
	HN: { postalCode: { pattern: /^([A-Z]{2})?[0-9]{5}$/ } },
	HR: { postalCode: { pattern: /^[0-9]{5}$/ } },
	HT: { postalCode: { pattern: /^[0-9]{4}$/ } },
	HU: { postalCode: { pattern: /^[0-9]{4}$/ } },
	ID: { postalCode: { pattern: /^[0-9]{5}$/ } },
	IE: { postalCode: { pattern: /^[AC-FHKNPRTV-Y][0-9][0-9W][ -]?[0-9AC-FHKNPRTV-Y]{4}$/ } },
	IL: { postalCode: { pattern: /^[0-9]{5}([0-9]{2})?$/ } },
	IM: { postalCode: { pattern: /^IM[0-9]{1,2}\s?[0-9][A-Z]{2}$/ } },
	IN: { postalCode: { pattern: /^[0-9]{3}\s?[0-9]{3}$/ } },
	IQ: { postalCode: { pattern: /^[0-9]{5}$/ } },
	IR: { postalCode: { pattern: /^[0-9]{5}-?[0-9]{5}$/ } },
	IS: { postalCode: { pattern: /^[0-9]{3}$/ } },
	IT: { postalCode: { pattern: /^[0-9]{5}$/ } },
	JE: { postalCode: { pattern: /^JE[0-9]{1,2}\s?[0-9][A-Z]{2}$/ } },
	JM: { postalCode: { pattern: /^[0-9]{2}$/ } },
	JO: { postalCode: { pattern: /^[0-9]{5}$/ } },
	JP: { postalCode: { pattern: /^[0-9]{3}(\s|-)?[0-9]{4}$/ } },
	KE: { postalCode: { pattern: /^[0-9]{5}$/ } },
	KG: { postalCode: { pattern: /^[0-9]{6}$/ } },
	KH: { postalCode: { pattern: /^[0-9]{5}$/ } },
	KR: { postalCode: { pattern: /^[0-9]{5}$/ } },
	KW: { postalCode: { pattern: /^[0-9]{5}$/ } },
	KY: { postalCode: { pattern: /^KY[0-9](\s|-)?[0-9]{4}$/ } },
	KZ: { postalCode: { pattern: /^[0-9]{6}$/ } },
	LA: { postalCode: { pattern: /^[0-9]{5}$/ } },
	LB: { postalCode: { pattern: /^[0-9]{4}(\s|-)?([0-9]{4})?$/ } },
	LC: { postalCode: { pattern: /^LC12(\s|-)?[0-9]{3}$/ } },
	LI: { postalCode: { pattern: /^[0-9]{4}$/ } },
	LK: { postalCode: { pattern: /^[0-9]{5}$/ } },
	LR: { postalCode: { pattern: /^[0-9]{4}$/ } },
	LS: { postalCode: { pattern: /^[0-9]{3}$/ } },
	LT: { postalCode: { pattern: /^(LT(\s|-)?)?[0-9]{5}$/ } },
	LU: { postalCode: { pattern: /^(L-?)?[0-9]{4}$/ } },
	LV: { postalCode: { pattern: /^(LV(\s|-)?)?[0-9]{4}$/ } },
	LY: { postalCode: { pattern: /^V-[0-9]{5}$/ } },
	MA: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MC: { postalCode: { pattern: /^980[0-9]{2}$/ } },
	MD: { postalCode: { pattern: /^(MD(\s|-)?)?[0-9]{4}$/ } },
	ME: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MG: { postalCode: { pattern: /^[0-9]{3}$/ } },
	MK: { postalCode: { pattern: /^[0-9]{4}$/ } },
	MM: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MN: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MQ: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MS: { postalCode: { pattern: /^(MSR(\s|-)?)?[0-9]{4}$/ } },
	MT: { postalCode: { pattern: /^[A-Z]{3}(\s|-)?[0-9]{4}$/ } },
	MU: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MX: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MY: { postalCode: { pattern: /^[0-9]{5}$/ } },
	MZ: { postalCode: { pattern: /^[0-9]{4}$/ } },
	NA: { postalCode: { pattern: /^[0-9]{5}$/ } },
	NC: { postalCode: { pattern: /^988[0-9]{2}$/ } },
	NG: { postalCode: { pattern: /^[0-9]{6}$/ } },
	NI: { postalCode: { pattern: /^[0-9]{5}$/ } },
	NL: {
		postalCode: { pattern: /^[1-9][0-9]{3}\s?(?!SA|SD|SS)[A-Z]{2}$/ },
		houseNumber: { required: !0 }
	},
	NO: { postalCode: { pattern: /^[0-9]{4}$/ } },
	NP: { postalCode: { pattern: /^[0-9]{5}$/ } },
	NZ: { postalCode: { pattern: /^[0-9]{4}$/ } },
	OM: { postalCode: { pattern: /^[0-9]{3}$/ } },
	PE: { postalCode: { pattern: /^[0-9]{5}$/ } },
	PF: { postalCode: { pattern: /^987[0-9]{2}$/ } },
	PG: { postalCode: { pattern: /^[0-9]{3}$/ } },
	PH: { postalCode: { pattern: /^[0-9]{4}$/ } },
	PK: { postalCode: { pattern: /^[0-9]{5}$/ } },
	PL: { postalCode: { pattern: /^[0-9]{2}-?[0-9]{3}$/ } },
	PM: { postalCode: { pattern: /^975[0-9]{2}$/ } },
	PN: { postalCode: { pattern: /^PCRN(\s|-)?1ZZ$/ } },
	PR: { postalCode: { pattern: /^[0-9]{5}(-[0-9]{4})?$/ } },
	PT: { postalCode: { pattern: /^[0-9]{4}-?([0-9]{3})$/ } },
	PY: { postalCode: { pattern: /^[0-9]{4}$/ } },
	RE: { postalCode: { pattern: /^974[0-9]{2}$/ } },
	RO: { postalCode: { pattern: /^[0-9]{6}$/ } },
	RS: { postalCode: { pattern: /^[0-9]{5}$/ } },
	RU: { postalCode: { pattern: /^[0-9]{6}$/ } },
	SA: { postalCode: { pattern: /^[0-9]{5}(-[0-9]{4})?$/ } },
	SD: { postalCode: { pattern: /^[0-9]{5}$/ } },
	SE: { postalCode: { pattern: /^(SE(\s|-)?)?[0-9]{3}\s?[0-9]{2}$/ } },
	SG: { postalCode: { pattern: /^[0-9]{6}$/ } },
	SI: { postalCode: { pattern: /^[0-9]{4}$/ } },
	SK: { postalCode: { pattern: /^[0-9]{3}\s?[0-9]{2}$/ } },
	SM: { postalCode: { pattern: /^4789[0-9]$/ } },
	SN: { postalCode: { pattern: /^[0-9]{5}$/ } },
	SO: { postalCode: { pattern: /^[A-Z]{2}(\s|-)?[0-9]{5}$/ } },
	SV: { postalCode: { pattern: /^[0-9]{4}$/ } },
	SZ: { postalCode: { pattern: /^[A-Z][0-9]{3}$/ } },
	TC: { postalCode: { pattern: /^TKCA(\s|-)?1ZZ$/ } },
	TH: { postalCode: { pattern: /^[0-9]{5}$/ } },
	TJ: { postalCode: { pattern: /^[0-9]{6}$/ } },
	TM: { postalCode: { pattern: /^[0-9]{6}$/ } },
	TN: { postalCode: { pattern: /^[0-9]{4}$/ } },
	TR: { postalCode: { pattern: /^[0-9]{5}$/ } },
	TT: { postalCode: { pattern: /^[0-9]{6}$/ } },
	TW: { postalCode: { pattern: /^[0-9]{3}((\s|-)?[0-9]{2,3})?$/ } },
	TZ: { postalCode: { pattern: /^[0-9]{5}$/ } },
	UA: { postalCode: { pattern: /^[0-9]{5}$/ } },
	US: { postalCode: { pattern: /^[0-9]{5}(-[0-9]{4})?$/ } },
	UY: { postalCode: { pattern: /^[0-9]{5}$/ } },
	UZ: { postalCode: { pattern: /^[0-9]{6}$/ } },
	VA: { postalCode: { pattern: /^00120$/ } },
	VC: { postalCode: { pattern: /^(VC(\s|-)?)?[0-9]{4}$/ } },
	VE: { postalCode: { pattern: /^[0-9]{4}(\s|-)?[A-Z]{0,1}$/ } },
	VG: { postalCode: { pattern: /^VG[0-9]{4}$/ } },
	VI: { postalCode: { pattern: /^[0-9]{5}(\s|-)?([0-9]{4})?$/ } },
	VN: { postalCode: { pattern: /^[0-9]{6}$/ } },
	WS: { postalCode: { pattern: /^([A-Z]{2}(\s|-)?)?[0-9]{4}$/ } },
	XK: { postalCode: { pattern: /^[0-9]{5}$/ } },
	YT: { postalCode: { pattern: /^976[0-9]{2}$/ } },
	ZA: { postalCode: { pattern: /^[0-9]{4}$/ } },
	ZM: { postalCode: { pattern: /^[0-9]{5}$/ } }
};
//#endregion
//#region src/utils/isPostalCodeOptional.ts
function M(e) {
	return !j[e]?.postalCode?.pattern;
}
//#endregion
//#region src/utils/isAddressFieldRequired.ts
function N(e, t) {
	return t === "postalCode" ? !M(e) : j[e]?.[t]?.required ?? A[t];
}
//#endregion
//#region src/utils/isValidPostalCode.ts
function P(e, t) {
	if (M(t)) return !0;
	if (!e?.trim()) return !1;
	let n = e.trim().replace(/\s+/, " ").toUpperCase();
	return j[t].postalCode.pattern.test(n);
}
//#endregion
export { C as AddressSchema, m as Alpha2CountryCode, b as Alpha2CountryCodeSchema, T as ProblemDetailsInvalidRequestSyntaxSchema, w as ProblemDetailsSchema, l as StateCodeOfCanada, S as StateCodeOfCanadaSchema, f as StateCodeOfTheUnitedStatesOfAmerica, x as StateCodeOfTheUnitedStatesOfAmericaSchema, E as ValidateSchema, g as addressAcceptanceApiUrl, _ as addressApiUrl, o as getAddresses, e as getValidate, N as isAddressFieldRequired, M as isPostalCodeOptional, P as isValidPostalCode, v as useAddressService, u as zAddress, p as zAlpha2CountryCode, t as zGetAddressesData, s as zGetAddressesResponse, h as zGetValidateData, n as zGetValidateResponse, r as zProblemDetails, d as zProblemDetailsInvalidRequestSyntax, c as zStateCodeOfCanada, a as zStateCodeOfTheUnitedStatesOfAmerica, i as zValidate };
